import instance from '@apis/instance';

class TestUserApi {
    static isTestUser(): Promise<never> {
        return instance.head('/test-user');
    }
}

export default TestUserApi;
